import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../redux/store'
import { getCouriersActionAsync } from '../redux/actions/courierActions'

export const useCourier = () => {
  const { couriersState } = useSelector((state: RootState) => state.courier)
  const dispatch = useDispatch()

  const getCouriers = () => {
    dispatch(getCouriersActionAsync())
  }

  const courierServices: any =
    couriersState.couriers !== undefined &&
    couriersState.couriers.reduce(
      (prev: any, next) => prev.concat(next.courierServices),
      []
    )

  return { couriersState, getCouriers, courierServices }
}
